import {put, takeLatest, call} from 'redux-saga/effects';
import * as productService from "../../../../services/productService";
import {
    DELETE_PRODUCT,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_ERROR
}
    from "../../../actions/menu/products";

function* deleteProductSaga(action) {
    try {
        yield call(productService.DeleteProduct, action.payload)
        yield put({
            type: DELETE_PRODUCT_SUCCESS,
            payload: action.payload.payload
        });

    } catch (error) {
        yield put({
            type: DELETE_PRODUCT_ERROR,error: error.data
        });
    }
}


export function* deleteProductSagaWatcher() {
    yield takeLatest(DELETE_PRODUCT, deleteProductSaga);
}